import axios from '@axios'

export default {
  list: pagina => axios.get(`${process.env.VUE_APP_WCOND_API}/correspondencias/${pagina}`),
  obter: id => axios.get(`${process.env.VUE_APP_WCOND_API}/correspondencia/${id}`),
  listEventos: id => axios.get(`${process.env.VUE_APP_WCOND_API}/correspondencia/evento/${id}`),
  confirmar: correspondencia => axios.post(`${process.env.VUE_APP_WCOND_API}/correspondencia/confirmar`, correspondencia),
  devolver: correspondencia => axios.post(`${process.env.VUE_APP_WCOND_API}/correspondencia/devolver`, correspondencia),
}
